var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSavings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 39.7",
    style: {
      enableBackground: "new 0 0 39.7 39.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M27.2,19c0.5,0,1-0.2,1.3-0.5c0.4-0.4,0.5-0.8,0.5-1.3s-0.2-1-0.5-1.3c-0.3-0.3-0.8-0.5-1.3-0.5 s-1,0.2-1.3,0.5c-0.3,0.3-0.5,0.8-0.5,1.3s0.2,1,0.5,1.3S26.6,19,27.2,19z M12.5,15.3h9.2v-3.6h-9.2V15.3z M6.1,37.3 c-1-3.5-2.1-7-3.1-10.4c-1-3.5-1.5-7-1.5-10.7c0-2.8,1-5.2,2.9-7.2c2-2,4.3-2.9,7.2-2.9h9.2c0.9-1.2,2-2.1,3.2-2.7 c1.3-0.6,2.6-1,4.1-1c0.8,0,1.4,0.3,1.9,0.8s0.8,1.2,0.8,1.9c0,0.2,0,0.4-0.1,0.6c0,0.2-0.1,0.4-0.2,0.5c-0.1,0.3-0.2,0.7-0.3,1 c-0.1,0.4-0.2,0.7-0.3,1.1l4.2,4.2h4v12.8L32.9,27l-3.1,10.3h-10v-3.7h-3.7v3.7H6.1z M8.8,33.7h3.7V30h11v3.7h3.7l2.8-9.4l4.5-1.5 v-6.5h-1.8l-6.4-6.4c0-0.6,0-1.2,0.1-1.8s0.2-1.1,0.3-1.7c-0.9,0.2-1.7,0.7-2.3,1.3c-0.7,0.6-1.2,1.3-1.5,2.2H11.6 C9.8,9.8,8.3,10.5,7,11.7c-1.3,1.3-1.9,2.8-1.9,4.5c0,3,0.4,5.9,1.2,8.8S8,30.8,8.8,33.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSavings);
export default __webpack_public_path__ + "static/media/icon_savings.63bd0dd52447b2ea3ea50c8f8b419f57.svg";
export { ForwardRef as ReactComponent };